import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CampaignForm from "./CampaignForm";

const CreateCampaign = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <CampaignForm />
  </DashboardLayout>
);

export default CreateCampaign;
